import { IJuniferFile } from "./juniferComm.parser"
import { IJuniferCommEmail } from "./juniferCommEmail.types"

export class JuniferCommEmail implements IJuniferCommEmail {
  subject: string
  body: string
  deliveryStatus: string
  attachments: IJuniferFile[]

  constructor(
    subject: string,
    body: string,
    deliveryStatus: string,
    attachments: IJuniferFile[],
  ) {
    this.subject = subject
    this.body = body
    this.deliveryStatus = deliveryStatus
    this.attachments = attachments
  }
}
